import thumbnail from './ycc.png';
import Mediator from './Mediator';

export default {
    handle: 'curriculum_ycc',
    label: 'YCC',
    thumbnail,
    mediatorComponent: Mediator,
};
